'use client';

import ImageAdaptive from '@/components/ImageAdaptive';

interface BadgeUnitProps {
    badgeCd: string;
    achievementScore: number;
    isAwarded: boolean;
}

export default function BadgeUnit({ badgeCd, achievementScore, isAwarded }: BadgeUnitProps) {
    return (
        <>
            <div className="relative flex items-center justify-center pointer-events-none">
                <ImageAdaptive
                    src={`/images/achievement/badge/frame/badge-frame-${isAwarded ? achievementScore : 0}.svg`}
                    baseWidth={80}
                    breakpoints={{ lg: 100 }}
                />
                <div
                    className={`absolute flex items-center justify-center rounded-full w-[60%] min-w-[60%] h-[60%] min-h-[60%] pointer-events-none ${
                        achievementScore === 1
                            ? 'bg-color-achievement-badge-1'
                            : achievementScore === 2
                            ? 'bg-color-achievement-badge-2'
                            : achievementScore === 3
                            ? 'bg-color-achievement-badge-3'
                            : 'bg-color-achievement-badge-0'
                    }`}
                >
                    <ImageAdaptive
                        src={`/images/achievement/badge/badge-${isAwarded ? badgeCd : '0'}.svg`}
                        baseWidth={isAwarded ? 50 : 80}
                        className={isAwarded ? 'w-[80%] h-[80%]' : 'w-[100%] h-[100%]'}
                    />
                </div>
            </div>
        </>
    );
}
